import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

constructor(private http:HttpClient) { }

  Login_Action(username:string,password:string,hash:string,code:string,browser:string):Observable<any>{
    const body = {
      username: username,
      password:password,
      fname:hash,
      lname:code,
      create_username:browser
    };

    return this.http.post(environment.BaseUrl +"Daro/Login", body, { withCredentials: true }).pipe(
      map(data=>{
        return data
      })
    )
  }

  ResetPassword(OldPassowrd:string,NewPassword:string):Observable<any>{
    const body = {
      password: OldPassowrd,
      username:'',
      create_username:NewPassword
    };

    return this.http.post(environment.BaseUrl +"Daro/Login/ResetPassword",body).pipe(
      map(data=>{
        return data
      })
    )
  }

  MustChangePassword(NewPassword:string):Observable<any>{
    const body = {
      username:'',
      create_username:NewPassword
    };

    return this.http.post(environment.BaseUrl +"Daro/Login/MustChangePassword",body).pipe(
      map(data=>{
        return data
      })
    )
  }


  GetUserRole():Observable<any>{


    return this.http.get(environment.BaseUrl +"Daro/Login/GetUserRole").pipe(
      map(data=>{
        return data
      })
    )
  }

  RestCapcha(oldfile:string, oldChallenge:string):Observable<any>{
    const params = new HttpParams()
      .set('oldfile', oldfile || '')
      .set('oldChallenge', oldChallenge || '');
    return this.http.get(environment.BaseUrl +"Daro/Login/RestCapcha", { params }).pipe(
      map(data=>{
        return data
      })
    )
  }

  Exit():Observable<any>{


    return this.http.get(environment.BaseUrl +"Daro/Login/Exit", { withCredentials: true }).pipe(
      map(data=>{
        return data
      })
    )
  }

  Refresh(): Observable<any> {
    return this.http.post(
      environment.BaseUrl + "Daro/Login/Refresh",
      null,
      { withCredentials: true }
    ).pipe(
      map(data => data)
    );
  }


  AutoLogin(id:number):Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/AutoLogin?id="+id).pipe(
      map(data=>{
        return data
      })
    )
  }

  GetTokenStation():Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/GetTokenStation").pipe(
      map(data=>{
        return data
      })
    )
  }


  ExtensionTokenStation():Observable<any>{
    return this.http.get(environment.BaseUrl +"Daro/Login/ExtensionTokenStation").pipe(
      map(data=>{
        return data
      })
    )
  }

  SubmitUrl(link:string):Observable<any>{
    const params = new HttpParams()
      .set('link', link || '');
    return this.http.get(environment.BaseUrl +"Daro/Login/SubmitUrl", { params }).pipe(
      map(data=>{
        return data
      })
    )
  }

}
